module.exports = __webpack_public_path__ + "img/r7.98d16477.jpg";